/* Forstwald, Messung (defer). Reicht Ereignisse des Themes als fh_* an Shopify.analytics.publish weiter (Plan 03-conversion-system.md, Abschnitt 12).
   Das Skript sendet selbst nichts an Dritte. Wer die Ereignisse bekommt, entscheidet ein Custom Pixel in Shopify (Einstellungen, Customer Events),
   und der läuft erst nach der Einwilligung in Analyse. Ist die Customer Privacy API geladen und Analyse abgelehnt, veröffentlicht das Skript nichts.
   Keine personenbezogenen Daten: nie Name, Adresse, E-Mail, Kartentext des Gutscheins. Nicht im Theme (kommen aus Bundle-App und Shopify selbst):
   fh_bundle_view, fh_bundle_add, fh_newsletter_confirm. */
(() => {
  'use strict';
  const FW = window.Forstwald;
  if (!FW) return;
  const d = document;

  const allowed = () => {
    try {
      const c = window.Shopify && window.Shopify.customerPrivacy;
      return !(c && typeof c.analyticsProcessingAllowed === 'function' && c.analyticsProcessingAllowed() === false);
    } catch (e) {
      return true;
    }
  };
  const publish = (name, data) => {
    if (name !== 'fh_consent_state' && !allowed()) return;
    try {
      const a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') a.publish(name, data || {});
    } catch (e) {}
  };
  FW.track = publish;

  const info = (el) => (el && el.closest ? el.closest('fw-product-info') : null) || d.querySelector('fw-product-info');
  const pid = (el) => {
    const i = info(el);
    return i ? i.dataset.productId : undefined;
  };
  const sizeOf = (i) => {
    try {
      const si = i ? +i.dataset.sizeIndex : -1;
      return si >= 0 ? i.selected()[si] || null : null;
    } catch (e) {
      return null;
    }
  };
  const cartState = () => d.querySelector('[data-cart-state]');
  const lastSegment = (href) => {
    try {
      return new URL(href, location.href).pathname.split('/').filter(Boolean).pop() || '';
    } catch (e) {
      return '';
    }
  };

  /* Klicks */
  d.addEventListener('click', (e) => {
    const t = e.target;
    if (!t.closest) return;
    let el;
    if ((el = t.closest('.hero a.btn'))) publish('fh_hero_cta_click', { hero_variant: (el.closest('[data-hero-variant]') || { dataset: {} }).dataset.heroVariant || 'standard' });
    else if ((el = t.closest('a.welt-chip'))) publish('fh_welt_chip_click', { welt: lastSegment(el.href), ort: 'pdp' });
    else if ((el = t.closest('.welten__list a'))) publish('fh_welt_chip_click', { welt: lastSegment(el.href), ort: 'start' });
    else if (t.closest('[data-sticky-submit]')) {
      const i = info(t);
      const idx = i ? +i.dataset.sizeIndex : -1;
      publish('fh_sticky_atc_click', { product_id: pid(t), size_selected: idx < 0 ? true : !!sizeOf(i) });
    } else if ((el = t.closest('.trust a'))) {
      const h = el.getAttribute('href') || '';
      const goal = /versand/i.test(h) ? 'versand' : /rueckgabe|widerruf/i.test(h) ? 'rueckgabe' : /zahlung/i.test(h) ? 'zahlung' : '';
      if (goal) publish('fh_trust_link_click', { ziel: goal });
    } else if (t.closest('.recs .card a')) {
      const card = t.closest('[data-product-card]');
      publish('fh_recommendation_click', {
        quelle_product_id: pid(null),
        ziel_product_id: card ? card.dataset.productId : undefined,
        art: t.closest('[data-recs-manual]') ? 'manuell' : 'automatisch',
      });
    } else if (t.closest('#CartDrawer [data-cart-checkout]')) {
      const st = cartState();
      const bar = d.querySelector('#CartDrawer [data-free-shipping]');
      publish('fh_drawer_checkout_click', { cart_total: st ? +st.dataset.total : undefined, shipping_free: !!(bar && bar.classList.contains('is-reached')) });
    }
  });

  /* Formulare */
  d.addEventListener('submit', (e) => {
    const f = e.target;
    if (!(f instanceof HTMLFormElement)) return;
    if (f.matches('.cart-suggestion__form')) {
      const box = f.closest('[data-suggestion]');
      publish('fh_drawer_upsell_add', { product_id: box ? box.dataset.productId : undefined, regel: box ? box.dataset.rule : undefined });
    } else if (f.matches('.card__quick-form')) {
      const card = f.closest('[data-product-card]');
      publish('fh_quick_add_click', { product_id: card ? card.dataset.productId : undefined });
    } else if (f.matches('[data-notify-form]')) {
      const i = info(f);
      publish('fh_notify_me_submit', { product_id: pid(f), size: sizeOf(i) || undefined });
    } else if (f.matches('.signup')) {
      publish('fh_newsletter_submit', { ort: f.closest('footer') ? 'footer' : 'abschnitt', variante: 'standard' });
    } else if (f.matches('[data-product-form]') && d.querySelector('[data-gift-card-form]')) {
      const mail = f.querySelector('[name="properties[Recipient email]"]') || d.querySelector('[form="' + f.id + '"][name="properties[Recipient email]"]');
      const date = d.querySelector('[name="properties[Send on]"]');
      const i = info(f);
      if (mail && mail.value.trim()) publish('fh_giftcard_recipient_submit', { wert: i && i.variant ? i.variant.price : undefined, zustellung_sofort: !(date && date.value) });
    }
  });

  /* Auswahl */
  d.addEventListener('change', (e) => {
    const t = e.target;
    if (!t.matches) return;
    if (t.matches('[data-option-value]') && t.closest('[data-option-kind="size"]')) {
      const wrap = t.closest('.option__value');
      publish('fh_size_select', { product_id: pid(t), size: t.value, verfuegbar: !(wrap && wrap.querySelector('.is-soldout')) });
    } else if (t.matches('[data-cart-gift]')) {
      const card = t.closest('.cart-extras__gift');
      const note = card && card.querySelector('textarea');
      publish('fh_giftwrap_toggle', { an: t.checked, kartentext_genutzt: !!(note && note.value.trim()) });
    }
  });

  /* Akkordeons (toggle bubbelt nicht, deshalb in der Erfassungsphase) */
  d.addEventListener(
    'toggle',
    (e) => {
      const t = e.target;
      if (!t.matches || !t.open) return;
      if (t.matches('details.faq__item')) {
        const all = [...d.querySelectorAll('details.faq__item')];
        publish('fh_faq_open', { faq_id: 'faq-' + (all.indexOf(t) + 1) });
      } else if (t.matches('details.product__tab--shipping')) {
        publish('fh_return_info_open', { product_id: pid(t) });
      }
    },
    true
  );

  /* Ereignisse des Themes */
  FW.on('dialog:open', ({ id }) => {
    if (id === 'CartDrawer') {
      const st = cartState();
      publish('fh_drawer_open', { cart_total: st ? +st.dataset.total : undefined, item_count: st ? +st.dataset.count : undefined });
      const bar = d.querySelector('#CartDrawer [data-free-shipping]');
      if (bar) publish('fh_shipping_progress_view', { rest_bis_schwelle: +bar.dataset.remaining, schwelle: +bar.dataset.threshold });
      const sug = d.querySelector('#CartDrawer [data-suggestion]');
      if (sug) publish('fh_drawer_upsell_view', { product_id: sug.dataset.productId, regel: sug.dataset.rule });
    } else if (id && id.indexOf('SizeGuide-') === 0) {
      const i = info(null);
      publish('fh_size_guide_open', { product_id: pid(null), produkttyp: i ? i.dataset.productType : undefined });
    }
  });
  FW.on('variant:change', ({ variant }) => {
    if (!variant || variant.available) return;
    const i = info(null);
    publish('fh_notify_me_open', { product_id: pid(null), size: sizeOf(i) || undefined });
  });

  /* Einmal je Seitenaufruf: Sticky-Leiste erscheint, Newsletter-Formular sichtbar, QR-Landung */
  const sticky = d.querySelector('[data-sticky-atc]');
  if (sticky && 'MutationObserver' in window) {
    const mo = new MutationObserver(() => {
      if (sticky.getAttribute('aria-hidden') === 'false') {
        mo.disconnect();
        publish('fh_sticky_atc_show', { product_id: pid(sticky) });
      }
    });
    mo.observe(sticky, { attributes: true, attributeFilter: ['aria-hidden'] });
  }
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        publish('fh_newsletter_view', { ort: en.target.closest('footer') ? 'footer' : 'abschnitt' });
      });
    });
    d.querySelectorAll('form.signup').forEach((f) => io.observe(f));
  }
  try {
    const q = new URLSearchParams(location.search);
    if (/\/pages\/im-haus\/?$/.test(location.pathname) && q.get('utm_source') === 'qr') {
      publish('fh_qr_landing_view', { utm_medium: q.get('utm_medium') || undefined, utm_campaign: q.get('utm_campaign') || undefined });
    }
  } catch (e) {}

  /* Cookie-Auswahl: Das Banner meldet visitorConsentCollected, das Skript gibt nur Wahrheitswerte weiter. */
  d.addEventListener('visitorConsentCollected', (e) => {
    const c = (e && e.detail) || {};
    publish('fh_consent_state', { analyse: !!c.analyticsAllowed, marketing: !!c.marketingAllowed });
  });
})();
